import {cgiUnescape} from "./cgiUnescape"
import {EmbedCodeExtractor} from "./types"

/** Ruby setup `c.patterns` (pre_processor/soundcloud.rb:4-6) — the unescaped dot after `w` is in the source. */
const PATTERNS = [/src="(https:\/\/w.soundcloud.com\S+)"/i]

const TARGET_URL_REGEX = /url=([^&]*)/i

/**
 * Ruby CGI.unescapeHTML: only the five named entities plus decimal/hex numeric
 * references are decoded (cgi/util.rb).
 */
function cgiUnescapeHtml(value: string): string {
  return value.replace(/&(apos|amp|quot|gt|lt|#[0-9]+|#[xX][0-9A-Fa-f]+);/g, (full, entity: string) => {
    switch(entity) {
      case "apos": return "'"
      case "amp": return "&"
      case "quot": return "\""
      case "gt": return ">"
      case "lt": return "<"
    }
    const codePoint = entity[1] === "x" || entity[1] === "X"
      ? parseInt(entity.slice(2), 16)
      : parseInt(entity.slice(1), 10)
    if(codePoint > 0x10ffff) return full
    return String.fromCodePoint(codePoint)
  })
}

/**
 * Port of Tik::WebEmbedService::PreProcessor::Soundcloud — extracts the canonical
 * SoundCloud URL from the `url=` parameter of a w.soundcloud.com player iframe.
 * Percent-decoding via the shared isomorphic cgiUnescape (design D5).
 */
export const soundcloudPreProcessor: EmbedCodeExtractor = (input: string): string | null => {
  for(const pattern of PATTERNS) {
    const matchData = pattern.exec(input)
    if(matchData) {
      const iframeUrl = cgiUnescapeHtml(matchData[1])
      const match = TARGET_URL_REGEX.exec(iframeUrl)
      if(match) {
        return cgiUnescape(match[1])
      }
      // Ruby `process` falls through to nil when the player URL has no url= parameter.
      return null
    }
  }
  return null
}
